module.exports = __webpack_public_path__ + "assets/refresh.f083e304.svg";